import React from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';

import './components/css/HomeStyles.css';
import { SetTopTab } from './components/custom/TopTab';

// Import Link Pages For NavBar
import NavBar from './components/NavBar';
import HomePage from './components/Home';
import SignUpPage from './components/SignUp';
import LoginPage from './components/Login';
import DriversPage from './components/DriversPage';
import VehiclesPage from './components/VehiclesPage';
import ProfilePage from './components/ProfilePage';
import CustomerPage from './components/CustomerPage';
import SubContractorsPage from './components/SubContractorsPage';
import WarehousePage from './components/WarehousePage';
import DevPage from './components/DevPage';
import MessagesPage from './components/MessagesPage';
import ChatbotDemo from './pages/ChatbotDemo';
import CustomerPortal from './components/CustomerPortal';
import PrivacyPolicy from './components/PrivacyPolicy';
import MyTrainingPage from './components/MyTrainingPage';
import InvoicesPage from './components/InvoicesPage';

// Import Routing Functions For NavBar
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";

// providers
import { AuthProvider, useAuthProvider } from './providers/AuthProvider';
import { ThemeProvider } from './components/themeControl/ThemeProvider';
import { AlertProvider } from './providers/AlertProvider';
import { SupabaseProvider } from './providers/SupabaseProvider';

// AI Chatbot
import ChatbotLauncher from './components/custom/ChatbotLauncher';

const FeatureGuard = ({ feature, children }) => {
    const { features, isLoading } = useAuthProvider();
    if (isLoading || features === null) return null;
    if (features[feature] === false) {
        return (
            <div style={{ textAlign: 'center', marginTop: '30vh', height: '100vh', color: 'red' }}>
                <h3>Feature Unavailable</h3>
                <p>This feature is not enabled for your organisation. Please contact your administrator.</p>
            </div>
        );
    }
    return children;
};

const RoleGuard = ({ children }) => {
    const { isAdmin, isManager, isDev, isLoading } = useAuthProvider();
    if (isLoading) return null;
    if (!isAdmin && !isManager && !isDev) {
        return (
            <div style={{ textAlign: 'center', marginTop: '30vh', height: '100vh', color: 'red' }}>
                <h3>Unauthorised</h3>
                <p>You do not have permission to access this page.</p>
            </div>
        );
    }
    return children;
};

const App = () => {

    SetTopTab("LogiqOS");

    return (
        <Router>
            <AuthProvider>
                <SupabaseProvider>
                <ThemeProvider>
                    <AlertProvider>
                        <div className="container-fluid" style={{padding: '0px'}}>
                            <NavBar/>

                            {/*"""Assign routes to switch between pages"""*/}
                                <Routes>
                                    <Route path="/" element={<HomePage />}></Route>
                                    <Route path="/signup" element={<SignUpPage />}></Route>
                                    <Route path="/login"  element={<LoginPage />}></Route>
                                    <Route path="/drivers" element={<DriversPage />}></Route>
                                    <Route path="/vehicles" element={<VehiclesPage />}></Route>
                                    <Route path="/profile" element={<ProfilePage />}></Route>
                                    <Route path="/warehouse" element={<FeatureGuard feature="warehouse"><WarehousePage /></FeatureGuard>}></Route>
                                    <Route path="/dev" element={<DevPage />}></Route>
                                    <Route path="/customers" element={<CustomerPage />}></Route>
                                    <Route path="/subcontractors" element={<SubContractorsPage />}></Route>
                                    <Route path="/messages" element={<RoleGuard><FeatureGuard feature="messaging"><MessagesPage /></FeatureGuard></RoleGuard>}></Route>
                                    <Route path="/chatbot-demo" element={<FeatureGuard feature="ai"><ChatbotDemo /></FeatureGuard>}></Route>
                                    <Route path="/customer-portal" element={<CustomerPortal />}></Route>
                                    <Route path="/mobileprivacypolicy" element={<PrivacyPolicy />}></Route>
                                    <Route path="/my-training" element={<FeatureGuard feature="training"><MyTrainingPage /></FeatureGuard>}></Route>
                                    <Route path="/invoices" element={<FeatureGuard feature="invoicing"><InvoicesPage /></FeatureGuard>}></Route>
                                </Routes>
                            
                            {/* AI Chatbot Launcher - Available on all pages */}
                            <ChatbotLauncher />
                        </div>
                    </AlertProvider>
                </ThemeProvider>
                </SupabaseProvider>
            </AuthProvider>
        </Router>

    )
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App tab="home" />);